import styled from 'styled-components';

export const SideDiv = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  align-items: flex-end;
  padding: 12px;
  padding-right: 24px;
`;

export const LastUpdatedOn = styled.div`
  min-width: 265px;
  width: fit-content;
  column-gap: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    text-underline-position: under;
    font-size: 0.8rem;
    svg {
      width: 12px;
      height: 12px;
      margin-right: 4px;
    }
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  p {
    font-size: 0.8rem;
  }
`;
